import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFilterChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 8,
	viewBox: "0 0 11 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10 6.5L5.5 2L1 6.5",
		stroke: "white",
		strokeWidth: 1.5
	})
});
export default SvgFilterChevronUp;
